/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomPersonTitleValue from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleValue/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/AddPersonRelation/Content/Details/Title"
  
}) {
let personTitleValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'title',
})
  return (<React.Fragment
>
<div
  data-testid="Title.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Title"
 weight="semibold"
/>
<DataVaxiomPersonTitleValue
  viewPath={`${viewPath}/DataVaxiomPersonTitleValue`}
 data="person.title"
 value={personTitleValueData}
/>
</div>
{children}
</React.Fragment>)
}